/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiClientEnum } from '../model/apiClientEnum';
// @ts-ignore
import { Attachment } from '../model/attachment';
// @ts-ignore
import { AuftragLog } from '../model/auftragLog';
// @ts-ignore
import { CompanyIdModel } from '../model/companyIdModel';
// @ts-ignore
import { IdsBySebuToken } from '../model/idsBySebuToken';
// @ts-ignore
import { LogLevel } from '../model/logLevel';
// @ts-ignore
import { NODataPagedResultOfferListItem } from '../model/nODataPagedResultOfferListItem';
// @ts-ignore
import { NODataPagedResultOfferOrderListItem } from '../model/nODataPagedResultOfferOrderListItem';
// @ts-ignore
import { NODataPagedResultOfferOrderViewItem } from '../model/nODataPagedResultOfferOrderViewItem';
// @ts-ignore
import { OfferApplicationInfo } from '../model/offerApplicationInfo';
// @ts-ignore
import { OfferApprovalMail } from '../model/offerApprovalMail';
// @ts-ignore
import { OfferApprovalRequest } from '../model/offerApprovalRequest';
// @ts-ignore
import { OfferDates } from '../model/offerDates';
// @ts-ignore
import { OfferFinalizeRefreshDates } from '../model/offerFinalizeRefreshDates';
// @ts-ignore
import { OfferFinalizeV3 } from '../model/offerFinalizeV3';
// @ts-ignore
import { OfferOptionalDates } from '../model/offerOptionalDates';
// @ts-ignore
import { OfferOrderActionsV3 } from '../model/offerOrderActionsV3';
// @ts-ignore
import { OfferOrderAndOfferSearchFilterSortOrder } from '../model/offerOrderAndOfferSearchFilterSortOrder';
// @ts-ignore
import { OfferOrderCommentV3 } from '../model/offerOrderCommentV3';
// @ts-ignore
import { OfferOrderCorrectV3 } from '../model/offerOrderCorrectV3';
// @ts-ignore
import { OfferOrderCreateV3 } from '../model/offerOrderCreateV3';
// @ts-ignore
import { OfferOrderEditV3 } from '../model/offerOrderEditV3';
// @ts-ignore
import { OfferOrderSearchFilterSortOrder } from '../model/offerOrderSearchFilterSortOrder';
// @ts-ignore
import { OfferOrderStandardLayoutRenderRequestV3 } from '../model/offerOrderStandardLayoutRenderRequestV3';
// @ts-ignore
import { OfferOrderStatusEnum } from '../model/offerOrderStatusEnum';
// @ts-ignore
import { OfferOrderUpdateOfferOrderNumberV3 } from '../model/offerOrderUpdateOfferOrderNumberV3';
// @ts-ignore
import { OfferOrderUpgradeV3 } from '../model/offerOrderUpgradeV3';
// @ts-ignore
import { OfferOrderV3 } from '../model/offerOrderV3';
// @ts-ignore
import { OfferSearchFilterSortOrder } from '../model/offerSearchFilterSortOrder';
// @ts-ignore
import { OfferStatusEnum } from '../model/offerStatusEnum';
// @ts-ignore
import { OfferV3 } from '../model/offerV3';
// @ts-ignore
import { ProductEnum } from '../model/productEnum';
// @ts-ignore
import { ProductTypeEnum } from '../model/productTypeEnum';
// @ts-ignore
import { ProductVariantEnum } from '../model/productVariantEnum';
// @ts-ignore
import { WorkflowStatusEnum } from '../model/workflowStatusEnum';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    OfferServiceInterface
} from './offer.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class OfferService implements OfferServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Sets the offer order state to the given state.
     * @param offerOrderId 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public administrationResetOfferOrderAdmin(offerOrderId: number, state?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public administrationResetOfferOrderAdmin(offerOrderId: number, state?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public administrationResetOfferOrderAdmin(offerOrderId: number, state?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public administrationResetOfferOrderAdmin(offerOrderId: number, state?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling administrationResetOfferOrderAdmin.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (state !== undefined && state !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>state, 'state');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/resetOfferOrder`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param offerOrderId Id of the offer ORder to Update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public administrationStornoOfferOrderAdmin(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public administrationStornoOfferOrderAdmin(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public administrationStornoOfferOrderAdmin(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public administrationStornoOfferOrderAdmin(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling administrationStornoOfferOrderAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/stornoOfferOrder`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param offerOrderId Id of the offer ORder to Update
     * @param durationString new Duration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public administrationUpdateOfferOrderDurationAdmin(offerOrderId: number, durationString?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public administrationUpdateOfferOrderDurationAdmin(offerOrderId: number, durationString?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public administrationUpdateOfferOrderDurationAdmin(offerOrderId: number, durationString?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public administrationUpdateOfferOrderDurationAdmin(offerOrderId: number, durationString?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling administrationUpdateOfferOrderDurationAdmin.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (durationString !== undefined && durationString !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>durationString, 'durationString');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/changeDuration`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exports a CSV for offer orders by using a search filter.
     * @param offerName 
     * @param externalOfferId 
     * @param companySearchTerm 
     * @param onlineAt 
     * @param offerOrderNumber 
     * @param productTypes 
     * @param products 
     * @param companyId 
     * @param orderBy 
     * @param includeCanceledOfferOrders 
     * @param publishedAtOrAfter 
     * @param publishedAtOrBefore 
     * @param createdAtOrAfter 
     * @param createdAtOrBefore 
     * @param offerOrderStates 
     * @param topJob 
     * @param tableEntry 
     * @param jobBlitz 
     * @param kalaydo 
     * @param itJobs 
     * @param tenhil 
     * @param refresh 
     * @param isSebu 
     * @param socialMedia 
     * @param workflowStates 
     * @param skip 
     * @param take 
     * @param resellerId If you are system admin, you can restrict searches to a reseller if you set this field.  Leave empty if you want to search for ALL records or if you are not system admin.  If you are system admin and set this field to any but your own reseller id you will  get a validation error.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportOfferOrders(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<Blob>;
    public exportOfferOrders(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public exportOfferOrders(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public exportOfferOrders(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (offerName !== undefined && offerName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerName, 'OfferName');
        }
        if (externalOfferId !== undefined && externalOfferId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalOfferId, 'ExternalOfferId');
        }
        if (companySearchTerm !== undefined && companySearchTerm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companySearchTerm, 'CompanySearchTerm');
        }
        if (onlineAt !== undefined && onlineAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>onlineAt, 'OnlineAt');
        }
        if (offerOrderNumber !== undefined && offerOrderNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerOrderNumber, 'OfferOrderNumber');
        }
        if (productTypes) {
            productTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductTypes');
            })
        }
        if (products) {
            products.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'Products');
            })
        }
        if (companyId !== undefined && companyId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companyId, 'CompanyId');
        }
        if (orderBy !== undefined && orderBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderBy, 'OrderBy');
        }
        if (includeCanceledOfferOrders !== undefined && includeCanceledOfferOrders !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeCanceledOfferOrders, 'IncludeCanceledOfferOrders');
        }
        if (publishedAtOrAfter !== undefined && publishedAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrAfter, 'PublishedAtOrAfter');
        }
        if (publishedAtOrBefore !== undefined && publishedAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrBefore, 'PublishedAtOrBefore');
        }
        if (createdAtOrAfter !== undefined && createdAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrAfter, 'CreatedAtOrAfter');
        }
        if (createdAtOrBefore !== undefined && createdAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrBefore, 'CreatedAtOrBefore');
        }
        if (offerOrderStates) {
            offerOrderStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OfferOrderStates');
            })
        }
        if (topJob !== undefined && topJob !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>topJob, 'TopJob');
        }
        if (tableEntry !== undefined && tableEntry !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tableEntry, 'TableEntry');
        }
        if (jobBlitz !== undefined && jobBlitz !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>jobBlitz, 'JobBlitz');
        }
        if (kalaydo !== undefined && kalaydo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>kalaydo, 'Kalaydo');
        }
        if (itJobs !== undefined && itJobs !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itJobs, 'ItJobs');
        }
        if (tenhil !== undefined && tenhil !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tenhil, 'Tenhil');
        }
        if (refresh !== undefined && refresh !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>refresh, 'Refresh');
        }
        if (isSebu !== undefined && isSebu !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isSebu, 'IsSebu');
        }
        if (socialMedia !== undefined && socialMedia !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>socialMedia, 'SocialMedia');
        }
        if (workflowStates) {
            workflowStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'WorkflowStates');
            })
        }
        if (skip !== undefined && skip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>skip, 'Skip');
        }
        if (take !== undefined && take !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>take, 'Take');
        }
        if (resellerId !== undefined && resellerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resellerId, 'ResellerId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/v3/offerOrders/csv`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Exports a CSV for offers by using a search filter.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportOffers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<Blob>;
    public exportOffers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public exportOffers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public exportOffers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/v3/offers/csv`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the OfferOrder attachment.
     * @param offerOrderId The offer order id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOfferOrderAttachment(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<Attachment>;
    public getOfferOrderAttachment(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<Attachment>>;
    public getOfferOrderAttachment(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<Attachment>>;
    public getOfferOrderAttachment(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling getOfferOrderAttachment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Attachment>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/attachment`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Activates a single offer and resets workflow.
     * @param offerId 
     * @param offerDates 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeActivateAsync(offerId: number, offerDates?: OfferDates, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeActivateAsync(offerId: number, offerDates?: OfferDates, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeActivateAsync(offerId: number, offerDates?: OfferDates, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeActivateAsync(offerId: number, offerDates?: OfferDates, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeActivateAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/activate`,
            offerDates,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets the parent offer order\&#39;s application info fields.
     * @param offerId 
     * @param offerApplicationInfo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeApplication(offerId: number, offerApplicationInfo?: OfferApplicationInfo, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerFinalizeV3FinalizeApplication(offerId: number, offerApplicationInfo?: OfferApplicationInfo, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerFinalizeV3FinalizeApplication(offerId: number, offerApplicationInfo?: OfferApplicationInfo, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerFinalizeV3FinalizeApplication(offerId: number, offerApplicationInfo?: OfferApplicationInfo, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeApplication.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/application`,
            offerApplicationInfo,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the categories of a single offer.
     * @param offerId 
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeCategoryGroupsAsync(offerId: number, groupId: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeCategoryGroupsAsync(offerId: number, groupId: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeCategoryGroupsAsync(offerId: number, groupId: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeCategoryGroupsAsync(offerId: number, groupId: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeCategoryGroupsAsync.');
        }
        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling offerFinalizeV3FinalizeCategoryGroupsAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (groupId) {
            groupId.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'groupId');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/categoryGroups`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deactivates a single offer and resets workflow.
     * @param offerId 
     * @param offerOptionalDates 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeDeactivateAsync(offerId: number, offerOptionalDates?: OfferOptionalDates, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeDeactivateAsync(offerId: number, offerOptionalDates?: OfferOptionalDates, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeDeactivateAsync(offerId: number, offerOptionalDates?: OfferOptionalDates, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeDeactivateAsync(offerId: number, offerOptionalDates?: OfferOptionalDates, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeDeactivateAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/deactivate`,
            offerOptionalDates,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Extends a single offer and resets workflow.
     * @param offerId 
     * @param offerDates 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeExtendAsync(offerId: number, offerDates?: OfferDates, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeExtendAsync(offerId: number, offerDates?: OfferDates, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeExtendAsync(offerId: number, offerDates?: OfferDates, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeExtendAsync(offerId: number, offerDates?: OfferDates, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeExtendAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/extend`,
            offerDates,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finalizes an offer with a future start date.
     * @param offerId 
     * @param startDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeFutureStartDateOfferAsync(offerId: number, startDate?: Date, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeFutureStartDateOfferAsync(offerId: number, startDate?: Date, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeFutureStartDateOfferAsync(offerId: number, startDate?: Date, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeFutureStartDateOfferAsync(offerId: number, startDate?: Date, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeFutureStartDateOfferAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (startDate !== undefined && startDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDate, 'startDate');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/futureStartDate`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finalizes an offer to publish it.
     * @param offerId 
     * @param offerFinalizeV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizePublishOfferAsync(offerId: number, offerFinalizeV3?: OfferFinalizeV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizePublishOfferAsync(offerId: number, offerFinalizeV3?: OfferFinalizeV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizePublishOfferAsync(offerId: number, offerFinalizeV3?: OfferFinalizeV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizePublishOfferAsync(offerId: number, offerFinalizeV3?: OfferFinalizeV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizePublishOfferAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/publish`,
            offerFinalizeV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets the parent offer order\&#39;s refresh dates.
     * @param offerId 
     * @param offerFinalizeRefreshDates 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeRefreshDates(offerId: number, offerFinalizeRefreshDates?: OfferFinalizeRefreshDates, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerFinalizeV3FinalizeRefreshDates(offerId: number, offerFinalizeRefreshDates?: OfferFinalizeRefreshDates, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerFinalizeV3FinalizeRefreshDates(offerId: number, offerFinalizeRefreshDates?: OfferFinalizeRefreshDates, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerFinalizeV3FinalizeRefreshDates(offerId: number, offerFinalizeRefreshDates?: OfferFinalizeRefreshDates, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeRefreshDates.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/refreshDates`,
            offerFinalizeRefreshDates,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the requirements of a single offer.
     * @param offerId 
     * @param requirements 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeRequirementsAsync(offerId: number, requirements: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeRequirementsAsync(offerId: number, requirements: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeRequirementsAsync(offerId: number, requirements: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeRequirementsAsync(offerId: number, requirements: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeRequirementsAsync.');
        }
        if (requirements === null || requirements === undefined) {
            throw new Error('Required parameter requirements was null or undefined when calling offerFinalizeV3FinalizeRequirementsAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (requirements) {
            requirements.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'requirements');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/requirements`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finalizes an offer to set it into \&quot;InProgress\&quot;.
     * @param offerId 
     * @param externalOfferId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeSetIntoProgressOfferAsync(offerId: number, externalOfferId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeSetIntoProgressOfferAsync(offerId: number, externalOfferId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeSetIntoProgressOfferAsync(offerId: number, externalOfferId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeSetIntoProgressOfferAsync(offerId: number, externalOfferId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeSetIntoProgressOfferAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (externalOfferId !== undefined && externalOfferId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalOfferId, 'externalOfferId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/inProgress`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets the TotalLocation (\&quot;GesamtRegion\&quot;) of a single offer.
     * @param offerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3FinalizeTotalLocationAsync(offerId: number, body?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerFinalizeV3FinalizeTotalLocationAsync(offerId: number, body?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerFinalizeV3FinalizeTotalLocationAsync(offerId: number, body?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerFinalizeV3FinalizeTotalLocationAsync(offerId: number, body?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3FinalizeTotalLocationAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/totalLocation`,
            body,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets externalCostumerNumber, if no value is commited, it will be set to null
     * @param offerId 
     * @param externalCustomerNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3SetExternalCustomerNumber(offerId: number, externalCustomerNumber?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerFinalizeV3SetExternalCustomerNumber(offerId: number, externalCustomerNumber?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerFinalizeV3SetExternalCustomerNumber(offerId: number, externalCustomerNumber?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerFinalizeV3SetExternalCustomerNumber(offerId: number, externalCustomerNumber?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3SetExternalCustomerNumber.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (externalCustomerNumber !== undefined && externalCustomerNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalCustomerNumber, 'externalCustomerNumber');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/externalCustomerId`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sets externalLogoId, if no value is commited, it will be set to null
     * @param offerId 
     * @param externalLogoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerFinalizeV3SetExternalLogoId(offerId: number, externalLogoId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerFinalizeV3SetExternalLogoId(offerId: number, externalLogoId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerFinalizeV3SetExternalLogoId(offerId: number, externalLogoId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerFinalizeV3SetExternalLogoId(offerId: number, externalLogoId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerFinalizeV3SetExternalLogoId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (externalLogoId !== undefined && externalLogoId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalLogoId, 'externalLogoId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/finalize/externalLogoId`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Activates an Offer Order and its Offers.
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3ActivateOfferOrderAsync(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3ActivateOfferOrderAsync(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3ActivateOfferOrderAsync(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3ActivateOfferOrderAsync(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3ActivateOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/activate`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cancels an Offer Order.
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3CancelOfferOrderAsync(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3CancelOfferOrderAsync(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3CancelOfferOrderAsync(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3CancelOfferOrderAsync(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3CancelOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/cancel`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Corrects an Offer Order.
     * @param offerOrderId 
     * @param updateRenderData 
     * @param offerOrderCorrectV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3CorrectOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderCorrectV3?: OfferOrderCorrectV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3CorrectOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderCorrectV3?: OfferOrderCorrectV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3CorrectOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderCorrectV3?: OfferOrderCorrectV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3CorrectOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderCorrectV3?: OfferOrderCorrectV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3CorrectOfferOrderAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (updateRenderData !== undefined && updateRenderData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updateRenderData, 'updateRenderData');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/correct`,
            offerOrderCorrectV3,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates an Offer Order.
     * @param offerOrderCreateV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3CreateOfferOrderAsync(offerOrderCreateV3?: OfferOrderCreateV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3CreateOfferOrderAsync(offerOrderCreateV3?: OfferOrderCreateV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3CreateOfferOrderAsync(offerOrderCreateV3?: OfferOrderCreateV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3CreateOfferOrderAsync(offerOrderCreateV3?: OfferOrderCreateV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders`,
            offerOrderCreateV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deactivates an Offer Order and its Offers.
     * @param offerOrderId 
     * @param offerOrderCommentV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3DeactivateOfferOrderAsync(offerOrderId: number, offerOrderCommentV3?: OfferOrderCommentV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3DeactivateOfferOrderAsync(offerOrderId: number, offerOrderCommentV3?: OfferOrderCommentV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3DeactivateOfferOrderAsync(offerOrderId: number, offerOrderCommentV3?: OfferOrderCommentV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3DeactivateOfferOrderAsync(offerOrderId: number, offerOrderCommentV3?: OfferOrderCommentV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3DeactivateOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/deactivate`,
            offerOrderCommentV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes the offerOrder.
     * @param offerOrderId The offer order id.
     * @param deleteSebuCompany Delete the SEBU company.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3DeleteAsync(offerOrderId: number, deleteSebuCompany?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerOrderV3DeleteAsync(offerOrderId: number, deleteSebuCompany?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerOrderV3DeleteAsync(offerOrderId: number, deleteSebuCompany?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerOrderV3DeleteAsync(offerOrderId: number, deleteSebuCompany?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3DeleteAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (deleteSebuCompany !== undefined && deleteSebuCompany !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deleteSebuCompany, 'deleteSebuCompany');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edits the OfferOrder attachment.
     * @param offerOrderId The Offer Order ID.
     * @param zipToken A token for fetching the rendered offer order from the renderer.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3EditAttachmentByZipTokenOfferOrderAsync(offerOrderId: number, zipToken?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3EditAttachmentByZipTokenOfferOrderAsync(offerOrderId: number, zipToken?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3EditAttachmentByZipTokenOfferOrderAsync(offerOrderId: number, zipToken?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3EditAttachmentByZipTokenOfferOrderAsync(offerOrderId: number, zipToken?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3EditAttachmentByZipTokenOfferOrderAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (zipToken !== undefined && zipToken !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zipToken, 'zipToken');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/zipToken`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edits the OfferOrder attachment.
     * @param offerOrderId The Offer Order ID.
     * @param attachment The Offer Order attachment
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3EditAttachmentOfferOrderAsync(offerOrderId: number, attachment?: Attachment, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3EditAttachmentOfferOrderAsync(offerOrderId: number, attachment?: Attachment, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3EditAttachmentOfferOrderAsync(offerOrderId: number, attachment?: Attachment, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3EditAttachmentOfferOrderAsync(offerOrderId: number, attachment?: Attachment, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3EditAttachmentOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/attachment`,
            attachment,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edits an Offer Order.
     * @param offerOrderId The id of the offer order
     * @param updateRenderData If true, update the render data as well. Setting this to true and RenderData to null will delete the render data from the offer  order.
     * @param offerOrderEditV3 The object containing the changes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3EditOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderEditV3?: OfferOrderEditV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3EditOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderEditV3?: OfferOrderEditV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3EditOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderEditV3?: OfferOrderEditV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3EditOfferOrderAsync(offerOrderId: number, updateRenderData?: boolean, offerOrderEditV3?: OfferOrderEditV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3EditOfferOrderAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (updateRenderData !== undefined && updateRenderData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updateRenderData, 'updateRenderData');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/edit`,
            offerOrderEditV3,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all possible Offer Order actions.
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3GetOfferOrderActionsAsync(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderActionsV3>;
    public offerOrderV3GetOfferOrderActionsAsync(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderActionsV3>>;
    public offerOrderV3GetOfferOrderActionsAsync(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderActionsV3>>;
    public offerOrderV3GetOfferOrderActionsAsync(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3GetOfferOrderActionsAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<OfferOrderActionsV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/actions`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets an Offer Order.
     * @param offerOrderId 
     * @param includeRenderData 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3GetOfferOrderAsync(offerOrderId: number, includeRenderData?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3GetOfferOrderAsync(offerOrderId: number, includeRenderData?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3GetOfferOrderAsync(offerOrderId: number, includeRenderData?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3GetOfferOrderAsync(offerOrderId: number, includeRenderData?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3GetOfferOrderAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (includeRenderData !== undefined && includeRenderData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeRenderData, 'includeRenderData');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets offer order id by offer order number.
     * @param offerOrderNumber 
     * @param companyId 
     * @param resellerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3GetOfferOrderIdAsync(offerOrderNumber: string, companyId: number, resellerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<number>;
    public offerOrderV3GetOfferOrderIdAsync(offerOrderNumber: string, companyId: number, resellerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<number>>;
    public offerOrderV3GetOfferOrderIdAsync(offerOrderNumber: string, companyId: number, resellerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<number>>;
    public offerOrderV3GetOfferOrderIdAsync(offerOrderNumber: string, companyId: number, resellerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderNumber === null || offerOrderNumber === undefined) {
            throw new Error('Required parameter offerOrderNumber was null or undefined when calling offerOrderV3GetOfferOrderIdAsync.');
        }
        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling offerOrderV3GetOfferOrderIdAsync.');
        }
        if (resellerId === null || resellerId === undefined) {
            throw new Error('Required parameter resellerId was null or undefined when calling offerOrderV3GetOfferOrderIdAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<number>(`${this.configuration.basePath}/api/v3/resellers/${encodeURIComponent(String(resellerId))}/companies/${encodeURIComponent(String(companyId))}/offerOrders/${encodeURIComponent(String(offerOrderNumber))}/offerOrderId`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the hosting for a single Offer Order, rerender and rehost
     * @param externalOfferId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3GetOfferOrderLogAdmin(externalOfferId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<Array<AuftragLog>>;
    public offerOrderV3GetOfferOrderLogAdmin(externalOfferId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<Array<AuftragLog>>>;
    public offerOrderV3GetOfferOrderLogAdmin(externalOfferId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<Array<AuftragLog>>>;
    public offerOrderV3GetOfferOrderLogAdmin(externalOfferId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (externalOfferId !== undefined && externalOfferId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalOfferId, 'externalOfferId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<AuftragLog>>(`${this.configuration.basePath}/api/v3/offerOrders/offerOrderLog`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all possible Offer Order upgrades.
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3GetOfferOrderUpgradesAsync(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<Array<ProductEnum>>;
    public offerOrderV3GetOfferOrderUpgradesAsync(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<Array<ProductEnum>>>;
    public offerOrderV3GetOfferOrderUpgradesAsync(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<Array<ProductEnum>>>;
    public offerOrderV3GetOfferOrderUpgradesAsync(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3GetOfferOrderUpgradesAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ProductEnum>>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/upgrades`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validates if offer order number already exists for the reseller.
     * @param offerOrderNumber 
     * @param resellerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3OfferOrderByNumberAsync(offerOrderNumber?: string, resellerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerOrderV3OfferOrderByNumberAsync(offerOrderNumber?: string, resellerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerOrderV3OfferOrderByNumberAsync(offerOrderNumber?: string, resellerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerOrderV3OfferOrderByNumberAsync(offerOrderNumber?: string, resellerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (offerOrderNumber !== undefined && offerOrderNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerOrderNumber, 'offerOrderNumber');
        }
        if (resellerId !== undefined && resellerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resellerId, 'resellerId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.head<any>(`${this.configuration.basePath}/api/v3/offerOrders`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Changes the company of an OfferOrder.
     * @param offerOrderId The OfferOrder number and company Id.
     * @param deleteSebuCompany Delete the SEBU company.
     * @param companyIdModel New company Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3ReassignOfferOrderAsync(offerOrderId: number, deleteSebuCompany?: boolean, companyIdModel?: CompanyIdModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3ReassignOfferOrderAsync(offerOrderId: number, deleteSebuCompany?: boolean, companyIdModel?: CompanyIdModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3ReassignOfferOrderAsync(offerOrderId: number, deleteSebuCompany?: boolean, companyIdModel?: CompanyIdModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3ReassignOfferOrderAsync(offerOrderId: number, deleteSebuCompany?: boolean, companyIdModel?: CompanyIdModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3ReassignOfferOrderAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (deleteSebuCompany !== undefined && deleteSebuCompany !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deleteSebuCompany, 'deleteSebuCompany');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/reassign`,
            companyIdModel,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Renders the standard layout of an offer order. Pure calculation, no side effects.
     * @param offerOrderStandardLayoutRenderRequestV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3RenderStandardLayoutAsync(offerOrderStandardLayoutRenderRequestV3?: OfferOrderStandardLayoutRenderRequestV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<string>;
    public offerOrderV3RenderStandardLayoutAsync(offerOrderStandardLayoutRenderRequestV3?: OfferOrderStandardLayoutRenderRequestV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<string>>;
    public offerOrderV3RenderStandardLayoutAsync(offerOrderStandardLayoutRenderRequestV3?: OfferOrderStandardLayoutRenderRequestV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<string>>;
    public offerOrderV3RenderStandardLayoutAsync(offerOrderStandardLayoutRenderRequestV3?: OfferOrderStandardLayoutRenderRequestV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<string>(`${this.configuration.basePath}/api/v3/offerOrders/render`,
            offerOrderStandardLayoutRenderRequestV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches for offer orders and offers by using a search filter.
     * @param offerName 
     * @param externalOfferId 
     * @param companySearchTerm 
     * @param onlineAt 
     * @param offerOrderNumber 
     * @param productTypes 
     * @param products 
     * @param companyId 
     * @param orderBy 
     * @param includeCanceledOfferOrders 
     * @param publishedAtOrAfter 
     * @param publishedAtOrBefore 
     * @param createdAtOrAfter 
     * @param createdAtOrBefore 
     * @param offerOrderStates 
     * @param topJob 
     * @param tableEntry 
     * @param jobBlitz 
     * @param kalaydo 
     * @param itJobs 
     * @param tenhil 
     * @param refresh 
     * @param isSebu 
     * @param socialMedia 
     * @param workflowStates 
     * @param skip 
     * @param take 
     * @param resellerId If you are system admin, you can restrict searches to a reseller if you set this field.  Leave empty if you want to search for ALL records or if you are not system admin.  If you are system admin and set this field to any but your own reseller id you will  get a validation error.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3SearchOfferOrdersAndOffersAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<NODataPagedResultOfferOrderViewItem>;
    public offerOrderV3SearchOfferOrdersAndOffersAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<NODataPagedResultOfferOrderViewItem>>;
    public offerOrderV3SearchOfferOrdersAndOffersAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<NODataPagedResultOfferOrderViewItem>>;
    public offerOrderV3SearchOfferOrdersAndOffersAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, productTypes?: Array<ProductTypeEnum>, products?: Array<ProductEnum>, companyId?: number, orderBy?: OfferOrderAndOfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, tableEntry?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, tenhil?: boolean, refresh?: boolean, isSebu?: boolean, socialMedia?: boolean, workflowStates?: Array<WorkflowStatusEnum>, skip?: number, take?: number, resellerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (offerName !== undefined && offerName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerName, 'OfferName');
        }
        if (externalOfferId !== undefined && externalOfferId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalOfferId, 'ExternalOfferId');
        }
        if (companySearchTerm !== undefined && companySearchTerm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companySearchTerm, 'CompanySearchTerm');
        }
        if (onlineAt !== undefined && onlineAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>onlineAt, 'OnlineAt');
        }
        if (offerOrderNumber !== undefined && offerOrderNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerOrderNumber, 'OfferOrderNumber');
        }
        if (productTypes) {
            productTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductTypes');
            })
        }
        if (products) {
            products.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'Products');
            })
        }
        if (companyId !== undefined && companyId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companyId, 'CompanyId');
        }
        if (orderBy !== undefined && orderBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderBy, 'OrderBy');
        }
        if (includeCanceledOfferOrders !== undefined && includeCanceledOfferOrders !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeCanceledOfferOrders, 'IncludeCanceledOfferOrders');
        }
        if (publishedAtOrAfter !== undefined && publishedAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrAfter, 'PublishedAtOrAfter');
        }
        if (publishedAtOrBefore !== undefined && publishedAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrBefore, 'PublishedAtOrBefore');
        }
        if (createdAtOrAfter !== undefined && createdAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrAfter, 'CreatedAtOrAfter');
        }
        if (createdAtOrBefore !== undefined && createdAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrBefore, 'CreatedAtOrBefore');
        }
        if (offerOrderStates) {
            offerOrderStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OfferOrderStates');
            })
        }
        if (topJob !== undefined && topJob !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>topJob, 'TopJob');
        }
        if (tableEntry !== undefined && tableEntry !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tableEntry, 'TableEntry');
        }
        if (jobBlitz !== undefined && jobBlitz !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>jobBlitz, 'JobBlitz');
        }
        if (kalaydo !== undefined && kalaydo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>kalaydo, 'Kalaydo');
        }
        if (itJobs !== undefined && itJobs !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itJobs, 'ItJobs');
        }
        if (tenhil !== undefined && tenhil !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tenhil, 'Tenhil');
        }
        if (refresh !== undefined && refresh !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>refresh, 'Refresh');
        }
        if (isSebu !== undefined && isSebu !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isSebu, 'IsSebu');
        }
        if (socialMedia !== undefined && socialMedia !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>socialMedia, 'SocialMedia');
        }
        if (workflowStates) {
            workflowStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'WorkflowStates');
            })
        }
        if (skip !== undefined && skip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>skip, 'Skip');
        }
        if (take !== undefined && take !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>take, 'Take');
        }
        if (resellerId !== undefined && resellerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resellerId, 'ResellerId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json',
                'text/csv',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<NODataPagedResultOfferOrderViewItem>(`${this.configuration.basePath}/api/v3/offerOrdersWithOffers`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches for offer orders by using a search filter.
     * @param offerOrderNumber 
     * @param companySearchTerm 
     * @param publishedAtOrAfter 
     * @param publishedAtOrBefore 
     * @param createdAtOrAfter 
     * @param createdAtOrBefore 
     * @param offerOrderStates 
     * @param products 
     * @param productTypes 
     * @param productVariants 
     * @param originApiClients 
     * @param topJob 
     * @param jobBlitz 
     * @param kalaydo 
     * @param itJobs 
     * @param socialMedia 
     * @param companyId 
     * @param isSebuOfferOrder 
     * @param refresh 
     * @param orderBy 
     * @param includeCanceledOfferOrders 
     * @param skip 
     * @param take 
     * @param resellerId If you are system admin, you can restrict searches to a reseller if you set this field.  Leave empty if you want to search for ALL records or if you are not system admin.  If you are system admin and set this field to any but your own reseller id you will  get a validation error.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3SearchOfferOrdersAsync(offerOrderNumber?: string, companySearchTerm?: string, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, socialMedia?: boolean, companyId?: number, isSebuOfferOrder?: boolean, refresh?: boolean, orderBy?: OfferOrderSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<NODataPagedResultOfferOrderListItem>;
    public offerOrderV3SearchOfferOrdersAsync(offerOrderNumber?: string, companySearchTerm?: string, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, socialMedia?: boolean, companyId?: number, isSebuOfferOrder?: boolean, refresh?: boolean, orderBy?: OfferOrderSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<NODataPagedResultOfferOrderListItem>>;
    public offerOrderV3SearchOfferOrdersAsync(offerOrderNumber?: string, companySearchTerm?: string, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, socialMedia?: boolean, companyId?: number, isSebuOfferOrder?: boolean, refresh?: boolean, orderBy?: OfferOrderSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<NODataPagedResultOfferOrderListItem>>;
    public offerOrderV3SearchOfferOrdersAsync(offerOrderNumber?: string, companySearchTerm?: string, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, socialMedia?: boolean, companyId?: number, isSebuOfferOrder?: boolean, refresh?: boolean, orderBy?: OfferOrderSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, skip?: number, take?: number, resellerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (offerOrderNumber !== undefined && offerOrderNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerOrderNumber, 'OfferOrderNumber');
        }
        if (companySearchTerm !== undefined && companySearchTerm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companySearchTerm, 'CompanySearchTerm');
        }
        if (publishedAtOrAfter !== undefined && publishedAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrAfter, 'PublishedAtOrAfter');
        }
        if (publishedAtOrBefore !== undefined && publishedAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrBefore, 'PublishedAtOrBefore');
        }
        if (createdAtOrAfter !== undefined && createdAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrAfter, 'CreatedAtOrAfter');
        }
        if (createdAtOrBefore !== undefined && createdAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrBefore, 'CreatedAtOrBefore');
        }
        if (offerOrderStates) {
            offerOrderStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OfferOrderStates');
            })
        }
        if (products) {
            products.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'Products');
            })
        }
        if (productTypes) {
            productTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductTypes');
            })
        }
        if (productVariants) {
            productVariants.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductVariants');
            })
        }
        if (originApiClients) {
            originApiClients.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OriginApiClients');
            })
        }
        if (topJob !== undefined && topJob !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>topJob, 'TopJob');
        }
        if (jobBlitz !== undefined && jobBlitz !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>jobBlitz, 'JobBlitz');
        }
        if (kalaydo !== undefined && kalaydo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>kalaydo, 'Kalaydo');
        }
        if (itJobs !== undefined && itJobs !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itJobs, 'ItJobs');
        }
        if (socialMedia !== undefined && socialMedia !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>socialMedia, 'SocialMedia');
        }
        if (companyId !== undefined && companyId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companyId, 'CompanyId');
        }
        if (isSebuOfferOrder !== undefined && isSebuOfferOrder !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isSebuOfferOrder, 'IsSebuOfferOrder');
        }
        if (refresh !== undefined && refresh !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>refresh, 'Refresh');
        }
        if (orderBy !== undefined && orderBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderBy, 'OrderBy');
        }
        if (includeCanceledOfferOrders !== undefined && includeCanceledOfferOrders !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeCanceledOfferOrders, 'IncludeCanceledOfferOrders');
        }
        if (skip !== undefined && skip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>skip, 'Skip');
        }
        if (take !== undefined && take !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>take, 'Take');
        }
        if (resellerId !== undefined && resellerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resellerId, 'ResellerId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json',
                'text/csv',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<NODataPagedResultOfferOrderListItem>(`${this.configuration.basePath}/api/v3/offerOrders`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sends an Offer Order.
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3SendOfferOrderAsync(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3SendOfferOrderAsync(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3SendOfferOrderAsync(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3SendOfferOrderAsync(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3SendOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/send`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the hosting for a single Offer Order, rerender and rehost
     * @param offerOrderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3UpdateOfferOrderHostingAdmin(offerOrderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerOrderV3UpdateOfferOrderHostingAdmin(offerOrderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerOrderV3UpdateOfferOrderHostingAdmin(offerOrderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerOrderV3UpdateOfferOrderHostingAdmin(offerOrderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3UpdateOfferOrderHostingAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/updateHosting`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Changes the number of an OfferOrder.
     * @param offerOrderId 
     * @param offerOrderUpdateOfferOrderNumberV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3UpdateOfferOrderNumberAsync(offerOrderId: number, offerOrderUpdateOfferOrderNumberV3?: OfferOrderUpdateOfferOrderNumberV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3UpdateOfferOrderNumberAsync(offerOrderId: number, offerOrderUpdateOfferOrderNumberV3?: OfferOrderUpdateOfferOrderNumberV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3UpdateOfferOrderNumberAsync(offerOrderId: number, offerOrderUpdateOfferOrderNumberV3?: OfferOrderUpdateOfferOrderNumberV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3UpdateOfferOrderNumberAsync(offerOrderId: number, offerOrderUpdateOfferOrderNumberV3?: OfferOrderUpdateOfferOrderNumberV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3UpdateOfferOrderNumberAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/updateOfferOrderNumber`,
            offerOrderUpdateOfferOrderNumberV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Extends TopJob by offer order.
     * @param offerOrderId 
     * @param immediately 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3UpdateWorkflowTopJob(offerOrderId: number, immediately?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3UpdateWorkflowTopJob(offerOrderId: number, immediately?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3UpdateWorkflowTopJob(offerOrderId: number, immediately?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3UpdateWorkflowTopJob(offerOrderId: number, immediately?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3UpdateWorkflowTopJob.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (immediately !== undefined && immediately !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>immediately, 'immediately');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/UpdateWorkflowTopJob`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upgrades an Offer Order.
     * @param offerOrderId 
     * @param offerOrderUpgradeV3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerOrderV3UpgradeOfferOrderAsync(offerOrderId: number, offerOrderUpgradeV3?: OfferOrderUpgradeV3, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferOrderV3>;
    public offerOrderV3UpgradeOfferOrderAsync(offerOrderId: number, offerOrderUpgradeV3?: OfferOrderUpgradeV3, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferOrderV3>>;
    public offerOrderV3UpgradeOfferOrderAsync(offerOrderId: number, offerOrderUpgradeV3?: OfferOrderUpgradeV3, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferOrderV3>>;
    public offerOrderV3UpgradeOfferOrderAsync(offerOrderId: number, offerOrderUpgradeV3?: OfferOrderUpgradeV3, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerOrderId === null || offerOrderId === undefined) {
            throw new Error('Required parameter offerOrderId was null or undefined when calling offerOrderV3UpgradeOfferOrderAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<OfferOrderV3>(`${this.configuration.basePath}/api/v3/offerOrders/${encodeURIComponent(String(offerOrderId))}/upgrade`,
            offerOrderUpgradeV3,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Activates an Offer.
     * @param offerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3ActivateOfferAsync(offerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerV3ActivateOfferAsync(offerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerV3ActivateOfferAsync(offerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerV3ActivateOfferAsync(offerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3ActivateOfferAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/activate`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deactivates an Offer.
     * @param offerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3DeactivateOfferAsync(offerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerV3DeactivateOfferAsync(offerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerV3DeactivateOfferAsync(offerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerV3DeactivateOfferAsync(offerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3DeactivateOfferAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/deactivate`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Extends an Offer.
     * @param offerId The Offer ID
     * @param extendImmediately If the offer should be extended now or after expiration.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3ExtendOfferAsync(offerId: number, extendImmediately?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerV3ExtendOfferAsync(offerId: number, extendImmediately?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerV3ExtendOfferAsync(offerId: number, extendImmediately?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerV3ExtendOfferAsync(offerId: number, extendImmediately?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3ExtendOfferAsync.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (extendImmediately !== undefined && extendImmediately !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>extendImmediately, 'extendImmediately');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/extend`,
            null,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets offer id, offer order id and company id, by offer SebuToken.
     * @param token 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3GetIdsBySebuTokenAsync(token: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<IdsBySebuToken>;
    public offerV3GetIdsBySebuTokenAsync(token: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<IdsBySebuToken>>;
    public offerV3GetIdsBySebuTokenAsync(token: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<IdsBySebuToken>>;
    public offerV3GetIdsBySebuTokenAsync(token: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling offerV3GetIdsBySebuTokenAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<IdsBySebuToken>(`${this.configuration.basePath}/api/v3/offers/offerToken/${encodeURIComponent(String(token))}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Request a zip from Stellenanzeigen via SOAP
     * @param offerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3GetZipDownloadAsync(offerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<Blob>;
    public offerV3GetZipDownloadAsync(offerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Blob>>;
    public offerV3GetZipDownloadAsync(offerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Blob>>;
    public offerV3GetZipDownloadAsync(offerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3GetZipDownloadAsync.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/zip`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * The offer has been processed by the workflow team and is now waiting on approval from the customer.  Sends an email to the customer of the given offer. It contains a link to the reseller\&#39;s portal where the customer can approve the offer.
     * @param offerId 
     * @param offerApprovalRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3OfferApprovalRequestAsyncAdmin(offerId: number, offerApprovalRequest?: OfferApprovalRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferApprovalMail>;
    public offerV3OfferApprovalRequestAsyncAdmin(offerId: number, offerApprovalRequest?: OfferApprovalRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferApprovalMail>>;
    public offerV3OfferApprovalRequestAsyncAdmin(offerId: number, offerApprovalRequest?: OfferApprovalRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferApprovalMail>>;
    public offerV3OfferApprovalRequestAsyncAdmin(offerId: number, offerApprovalRequest?: OfferApprovalRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3OfferApprovalRequestAsyncAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<OfferApprovalMail>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/sendOfferApprovalRequest`,
            offerApprovalRequest,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches for offers by using a search filter
     * @param offerName 
     * @param externalOfferId 
     * @param companySearchTerm 
     * @param onlineAt 
     * @param offerOrderNumber 
     * @param offerStates 
     * @param workflowStates 
     * @param products 
     * @param productTypes 
     * @param productVariants 
     * @param originApiClients 
     * @param companyId 
     * @param isSebuOffer 
     * @param orderBy 
     * @param includeCanceledOfferOrders 
     * @param publishedAtOrAfter 
     * @param publishedAtOrBefore 
     * @param createdAtOrAfter 
     * @param createdAtOrBefore 
     * @param offerOrderStates 
     * @param topJob 
     * @param jobBlitz 
     * @param kalaydo 
     * @param itJobs 
     * @param refresh 
     * @param skip 
     * @param take 
     * @param resellerId If you are system admin, you can restrict searches to a reseller if you set this field.  Leave empty if you want to search for ALL records or if you are not system admin.  If you are system admin and set this field to any but your own reseller id you will  get a validation error.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3SearchViaResellerAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, offerStates?: Array<OfferStatusEnum>, workflowStates?: Array<WorkflowStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, companyId?: number, isSebuOffer?: boolean, orderBy?: OfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, refresh?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<NODataPagedResultOfferListItem>;
    public offerV3SearchViaResellerAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, offerStates?: Array<OfferStatusEnum>, workflowStates?: Array<WorkflowStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, companyId?: number, isSebuOffer?: boolean, orderBy?: OfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, refresh?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<NODataPagedResultOfferListItem>>;
    public offerV3SearchViaResellerAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, offerStates?: Array<OfferStatusEnum>, workflowStates?: Array<WorkflowStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, companyId?: number, isSebuOffer?: boolean, orderBy?: OfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, refresh?: boolean, skip?: number, take?: number, resellerId?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<NODataPagedResultOfferListItem>>;
    public offerV3SearchViaResellerAsync(offerName?: string, externalOfferId?: number, companySearchTerm?: string, onlineAt?: Date, offerOrderNumber?: string, offerStates?: Array<OfferStatusEnum>, workflowStates?: Array<WorkflowStatusEnum>, products?: Array<ProductEnum>, productTypes?: Array<ProductTypeEnum>, productVariants?: Array<ProductVariantEnum>, originApiClients?: Array<ApiClientEnum>, companyId?: number, isSebuOffer?: boolean, orderBy?: OfferSearchFilterSortOrder, includeCanceledOfferOrders?: boolean, publishedAtOrAfter?: Date, publishedAtOrBefore?: Date, createdAtOrAfter?: Date, createdAtOrBefore?: Date, offerOrderStates?: Array<OfferOrderStatusEnum>, topJob?: boolean, jobBlitz?: boolean, kalaydo?: boolean, itJobs?: boolean, refresh?: boolean, skip?: number, take?: number, resellerId?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json' | 'text/csv' | 'application/octet-stream', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (offerName !== undefined && offerName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerName, 'OfferName');
        }
        if (externalOfferId !== undefined && externalOfferId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>externalOfferId, 'ExternalOfferId');
        }
        if (companySearchTerm !== undefined && companySearchTerm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companySearchTerm, 'CompanySearchTerm');
        }
        if (onlineAt !== undefined && onlineAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>onlineAt, 'OnlineAt');
        }
        if (offerOrderNumber !== undefined && offerOrderNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offerOrderNumber, 'OfferOrderNumber');
        }
        if (offerStates) {
            offerStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OfferStates');
            })
        }
        if (workflowStates) {
            workflowStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'WorkflowStates');
            })
        }
        if (products) {
            products.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'Products');
            })
        }
        if (productTypes) {
            productTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductTypes');
            })
        }
        if (productVariants) {
            productVariants.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'ProductVariants');
            })
        }
        if (originApiClients) {
            originApiClients.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OriginApiClients');
            })
        }
        if (companyId !== undefined && companyId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>companyId, 'CompanyId');
        }
        if (isSebuOffer !== undefined && isSebuOffer !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isSebuOffer, 'IsSebuOffer');
        }
        if (orderBy !== undefined && orderBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderBy, 'OrderBy');
        }
        if (includeCanceledOfferOrders !== undefined && includeCanceledOfferOrders !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeCanceledOfferOrders, 'IncludeCanceledOfferOrders');
        }
        if (publishedAtOrAfter !== undefined && publishedAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrAfter, 'PublishedAtOrAfter');
        }
        if (publishedAtOrBefore !== undefined && publishedAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>publishedAtOrBefore, 'PublishedAtOrBefore');
        }
        if (createdAtOrAfter !== undefined && createdAtOrAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrAfter, 'CreatedAtOrAfter');
        }
        if (createdAtOrBefore !== undefined && createdAtOrBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAtOrBefore, 'CreatedAtOrBefore');
        }
        if (offerOrderStates) {
            offerOrderStates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OfferOrderStates');
            })
        }
        if (topJob !== undefined && topJob !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>topJob, 'TopJob');
        }
        if (jobBlitz !== undefined && jobBlitz !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>jobBlitz, 'JobBlitz');
        }
        if (kalaydo !== undefined && kalaydo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>kalaydo, 'Kalaydo');
        }
        if (itJobs !== undefined && itJobs !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itJobs, 'ItJobs');
        }
        if (refresh !== undefined && refresh !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>refresh, 'Refresh');
        }
        if (skip !== undefined && skip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>skip, 'Skip');
        }
        if (take !== undefined && take !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>take, 'Take');
        }
        if (resellerId !== undefined && resellerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resellerId, 'ResellerId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json',
                'text/csv',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<NODataPagedResultOfferListItem>(`${this.configuration.basePath}/api/v3/offers`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sends the expired mail.
     * @param offerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3SendExpiredMailAsyncAdmin(offerId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<OfferV3>;
    public offerV3SendExpiredMailAsyncAdmin(offerId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpResponse<OfferV3>>;
    public offerV3SendExpiredMailAsyncAdmin(offerId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<HttpEvent<OfferV3>>;
    public offerV3SendExpiredMailAsyncAdmin(offerId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Observable<any> {
        if (offerId === null || offerId === undefined) {
            throw new Error('Required parameter offerId was null or undefined when calling offerV3SendExpiredMailAsyncAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<OfferV3>(`${this.configuration.basePath}/api/v3/offers/${encodeURIComponent(String(offerId))}/sendExpiredMail`,
            null,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param msg 
     * @param level 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public offerV3Test(msg?: string, level?: LogLevel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public offerV3Test(msg?: string, level?: LogLevel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public offerV3Test(msg?: string, level?: LogLevel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public offerV3Test(msg?: string, level?: LogLevel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (msg !== undefined && msg !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>msg, 'msg');
        }
        if (level !== undefined && level !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>level, 'level');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKeyAuth) required
        localVarCredential = this.configuration.lookupCredential('apiKeyAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-Api-Key', localVarCredential);
        }

        // authentication (basicAuth) required
        localVarCredential = this.configuration.lookupCredential('basicAuth');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Basic ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' = 'json';
        if(localVarHttpHeaderAcceptSelected && localVarHttpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/test`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
